<div class="container bg-light-gray">
  <app-qp-mat-card-greened>
    <div class="logo-container">
      <img src="../../../assets/images/quantapower_logo.png" alt="quantapower logo" />
    </div>
    <app-qp-mat-card-greened-divider></app-qp-mat-card-greened-divider>
    <app-login-form (clickSubmit)="onClickSubmit($event)"></app-login-form>
    <div class="forgot-container">
      <button
        [disabled]="progressBarService.isShown$ | async"
        type="button"
        mat-button
        (click)="onClickForgot()"
        class="width-max"
      >
        Forgot password?
      </button>
    </div>
  </app-qp-mat-card-greened>
  <app-contact-us-footer></app-contact-us-footer>
</div>
